import update from 'immutability-helper';
import * as actionTypes from '../constants/actionTypes';
var initialState = {
    // User clicked play button so we're waiting for full project data
    // to load
    isAboutToPlay: false,
    isPlaying: false,
};
export default function player(state, action) {
    if (state === void 0) { state = initialState; }
    if (action.type === actionTypes.PLAY) {
        return update(state, {
            isAboutToPlay: { $set: true },
        });
    }
    if ((action.type === actionTypes.LOAD_FULL_PROJECT_DONE ||
        action.type === actionTypes.SET_PROJECT) &&
        state.isAboutToPlay) {
        return update(state, {
            isAboutToPlay: { $set: false },
            isPlaying: { $set: true },
        });
    }
    return state;
}
